import React from "react";
import { Globe, MapPin, BadgeCheck } from "lucide-react";

const internationalClients = [
  { title: "ContextLabs", desc: "Blockchain & Data Solutions" },
  { title: "US1 Industries", desc: "Enterprise Modernization" },
  { title: "Walchem", desc: "IoT & Big Data" },
  { title: "DCT", desc: "OTT Platform" },
  { title: "American Kennel Club (AKC)", desc: "IoT & Smart Devices" },
  { title: "Leverage Campus", desc: "EdTech Platform" },
  { title: "ContactNinja", desc: "SaaS - Contact Management" },
];

const domesticClients = [
  { title: "Indian Railway - Asansol Division", desc: "Railway Management System" },
  { title: "Indian Railway - Jamalpur Division", desc: "CBT System" },
  { title: "LeafyBus", desc: "AI Automation" },
  { title: "HoiChoi", desc: "OTT Platform" },
];

const ProductsProjects = () => {
  return (
    <section className="bg-[#001b4d] px-6 py-10">
      <div className="max-w-7xl mx-auto">

        {/* Main Heading */}
        <h1 className="text-white text-4xl font-bold text-center mb-10">Our Clients</h1>

        <div className="grid lg:grid-cols-2 gap-6">

          {/* LEFT CARD - International */}
          <div className="border border-[#173a70] rounded-2xl p-6">
            <div className="flex items-center gap-3 mb-6">
              <Globe size={28} className="text-cyan-300" />
              <h2 className="text-white text-2xl font-bold">International Clients <span className="text-cyan-400 text-base font-normal">(USA)</span></h2>
            </div>

            <div className="grid md:grid-cols-3 gap-4 mb-6">
              {internationalClients.map((item, index) => (
                <div key={index} className="border border-[#173a70] rounded-xl p-4 text-center">
                  <h3 className="text-white text-sm font-medium leading-snug">{item.title}</h3>
                  <p className="text-gray-400 text-xs mt-1">{item.desc}</p>
                </div>
              ))}
            </div>

            <div className="border border-[#173a70] rounded-xl p-4 flex gap-3">
              <BadgeCheck size={20} className="text-cyan-300 flex-shrink-0 mt-1" />
              <p className="text-gray-300 text-sm leading-relaxed">
                Built with self-hosted model options, API integrations, role-aware workflows, and data privacy as a default implementation concern.
              </p>
            </div>
          </div>

          {/* RIGHT CARD - Domestic */}
          <div className="border border-[#173a70] rounded-2xl p-6">
            <div className="flex items-center gap-3 mb-6">
              <MapPin size={28} className="text-cyan-300" />
              <h2 className="text-white text-2xl font-bold">Domestic Clients <span className="text-cyan-400 text-base font-normal">(India)</span></h2>
            </div>

            <div className="grid md:grid-cols-2 gap-4 mb-6">
              {domesticClients.map((item, index) => (
                <div key={index} className="border border-[#173a70] rounded-xl p-4 text-center">
                  <h3 className="text-white text-sm font-medium leading-snug">{item.title}</h3>
                  <p className="text-gray-400 text-xs mt-1">{item.desc}</p>
                </div>
              ))}
            </div>

            <div className="border border-[#173a70] rounded-xl p-4 flex gap-3">
              <BadgeCheck size={20} className="text-cyan-300 flex-shrink-0 mt-1" />
              <p className="text-gray-300 text-sm leading-relaxed">
                Delivering innovative solutions across railways, OTT, AI automation, and enterprise systems in India.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ProductsProjects;
